import React, { useEffect } from 'react';
import { Box, Button, Container, makeStyles, Paper, Typography } from '@material-ui/core';
import { Link, RouteComponentProps, useNavigate } from '@reach/router';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import NotFound from '../../../components/NotFound';
import AppBackLink from '../../../components/BackLink';
import { selectCartVoucherItems } from '../../../Cart/store/selectors';
import { ReactComponent as ArrowIcon } from '../../../images/svg/arrow.svg';
import { getPage } from '../../../utils/pages';
import RunningLine from 'components/RunningLine';
import ProductLoading from 'Product/components/Loading';
import VoucherGarment from 'Cart/components/VoucherGarment/VoucherGarment';
import { VoucherItem } from 'Voucher/intefaces/item';

// styles
const useStyles = makeStyles((theme) => {
  const s = (x) => theme.spacing(x);
  return {
    headingBlock: {
      position: 'relative',
    },
    arrowIcon: {
      position: 'absolute',
      top: s(0.5),
      left: -s(17),
      display: 'none',
      [theme.breakpoints.up('sm')]: {
        display: 'block',
      },
      [theme.breakpoints.up('xl')]: {
        top: s(1),
      },
    },
  };
});

// props
interface VoucherSuccessRouteProps {
  targetId: string;
}

/**
 * Product add-to-cart-success component.
 */
export default function VoucherSuccess({ targetId }: RouteComponentProps<VoucherSuccessRouteProps>) {
  const classes = useStyles();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const cartItems = useSelector(selectCartVoucherItems);
  const headingHtmlId = 'ProductSuccess-heading';
  // const buttonLabelHtmlId = 'ProductSuccess-addRepairButtonLabel';
  let voucherItems: VoucherItem[];

  useEffect(() => {
    if (voucherItems?.length === 0) {
      navigate('..');
    }
  });

  if (!targetId) {
    return <NotFound />;
  }

  if (!cartItems) {
    return <ProductLoading />;
  }
  //@ts-ignore
  voucherItems = cartItems;

  if (!voucherItems.length) {
    return null;
  }

  return (
    <Box>
      <RunningLine />
      <Container maxWidth="sm">
        <AppBackLink isGoBackActivated />
        <Box className={classes.headingBlock} px={{ xs: 0, sm: 2 }}>
          <Typography className="with-bar" id={headingHtmlId} variant="h1">
            {t('Successfully added to cart')}
          </Typography>
          <ArrowIcon className={classes.arrowIcon} />
        </Box>
        <Box mb={3} />
        <Paper aria-labelledby={headingHtmlId}>
          <VoucherGarment voucherItems={voucherItems} />
        </Paper>
        <Box mb={4} />
        <Box textAlign="center">
          <Button color="secondary" component={Link} to="../../" variant="contained">
            {t('Add another voucher')}
          </Button>
        </Box>
        <Box textAlign="center">
          <Button color="secondary" component={Link} to={getPage('cart')} variant="contained">
            {t('Go to cart')}
          </Button>
        </Box>
      </Container>
    </Box>
  );
}
